export const manifest = {
  screens: {
    scr_1qij2l: { name: "Board", route: "/", state: {"view":"board"}, position: {"x":160,"y":220} },
    scr_iyq4lb: { name: "List", route: "/", state: {"view":"list"}, position: {"x":1560,"y":220} },
  },
  sections: {
    sec_gzh2q2: { name: "Home View", x: 0, y: 0, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_gzh2q2", children: [
      { kind: "screen", id: "scr_1qij2l" },
      { kind: "screen", id: "scr_iyq4lb" },
    ] },
  ],
}
